export default __webpack_public_path__ + "static/media/p-methods.5c8eefe1.png";